<template lang="pug">
#email-view.custom-container
  .section-title Emails
  b-breadcrumb.breadcrumb(:items="breadcrumbs")
  ListEmail
</template>
<script>
import ListEmail from "../components/email/ListEmail";
export default {
  data () {
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Emails',
          active:true
        },
      ]
    }
  },
  components: {
    ListEmail
  },
};
</script>